<template>
  <main flex flex-col min-h-full>
    <Navigation fixed left-0 right-0 top-0 z-10 w-full />
    <div grow overflow-x-hidden mt-100px>
      <slot />
    </div>
    <FooterSimple />
  </main>
</template>
